<template>
  <!-- Brand logos require a white backdrop regardless of app theme, so the
       chip background is intentionally fixed white (not a theme token). -->
  <div class="logo-tile" :style="{ width: size + 'px', height: size + 'px', borderRadius: radius + 'px' }">
    <v-img v-if="logo" :src="logo" :alt="alt" contain />
    <v-icon v-else-if="icon" :icon="icon" class="logo-tile__icon" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    logo: { type: String, default: '' },
    icon: { type: String, default: '' },
    alt: { type: String, default: '' },
    size: { type: Number, default: 44 },
    radius: { type: Number, default: 10 }
  }
})
export default class LogoTile extends Vue {
  logo!: string
  icon!: string
  alt!: string
  size!: number
  radius!: number
}
</script>

<style scoped lang="scss">
.logo-tile {
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid var(--l-border, rgb(var(--v-theme-border-color)));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
}
.logo-tile__icon {
  color: #141414;
  font-size: 22px;
}
:deep(.v-img__img--contain) {
  object-fit: contain;
}
</style>
